import Typography from "./Typography";
export type { TypographyVariant } from "types/theme";

export default Typography;
